import { AxiosResponse } from 'axios'

import { CerebroResourceResponse } from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'

import { OrganizationProductsMinimumAllowedPriceListResponse } from './organizationProductsMinimumAllowedPriceTypes'

export const organizationProductsMinimumAllowedPriceKeys = {
    all: ['organization_products_minimum_allowed_price'] as const,
    list: (orgId: string | undefined, orgGroupId: string | undefined) =>
        [
            ...organizationProductsMinimumAllowedPriceKeys.all,
            'list',
            orgId,
            orgGroupId ?? null,
        ] as const,
}

export const getOrganizationProductsMinimumAllowedPrices = (): Promise<
    AxiosResponse<OrganizationProductsMinimumAllowedPriceListResponse>
> => orgScopedApiClient.get('/api/organization_products_minimum_allowed_price/')

interface MapPriceUpdateRow {
    product_id: string
    currency: string
    map_price: number | null
}

interface MapPriceUpdate {
    items: MapPriceUpdateRow[]
}

export const putOrganizationProductsMinimumAllowedPrices = (
    data: MapPriceUpdate
): Promise<CerebroResourceResponse<void>> =>
    orgScopedApiClient.put(
        '/api/organization_products_minimum_allowed_price/',
        data
    )
